import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { LABELS } from '../../../../constants'
import { Typography } from '../../../../components/Typography'
import { useContractCategoryDetailsContext } from '../../Providers/ContractCategoryDetailsContextProvider'

export const ViewContractCategory = () => {
  const { state } = useContractCategoryDetailsContext()
  const { details } = state

  return (
    <div className="contract-category-details-general__details__grid column">
      <div className="full-width">
        <FieldWithLabel
          title={LABELS.COMPLIANCE_REQUIREMENT}
          className="cc-details-item"
        >
          <Typography.Body1>
            {details.compliance_requirement || '-'}
          </Typography.Body1>
        </FieldWithLabel>
      </div>
    </div>
  )
}
